import { enumSortScope, kSortScopeName } from "../constants";
import { QSortCriteria } from "./QSortCriteria";
import { QXMLObject } from "./QXMLObject";

export class QSortConfig extends QXMLObject {
  constructor() {
    super();
    this.fSortList = null;
    this.fSortScope = null;
  }

  InitConfig(sortScope) {
    this.fSortList = [];
    this.fSortScope = sortScope;
    this.SetXMLElementName("qsortconfig");
  }

  GetSortScope() {
    return this.fSortScope;
  }

  GetSortScopeName() {
    return kSortScopeName[this.fSortScope];
  }

  SetSortScope(sortScope) {
    this.fSortScope = sortScope;
  }

  SetSortScopeByName(scopeName) {
    this.fSortScope = kSortScopeName.indexOf(scopeName);
  }

  GetNumCriteria() {
    return this.fSortList.length;
  }

  GetCriteriaValid() {
    var n = this.fSortList.length;
    if (n == 0) return false;

    for (var i = 0; i < n; i++) {
      var c = this.GetIndexCriteria(i);
      if (!c.CriteriaValid()) return false;
    }

    return true;
  }

  GetIndexCriteria(index) {
    return this.fSortList[index];
  }

  AddCriteria(fieldID, fieldName, ascending) {
    var sortCriteria = new QSortCriteria();
    sortCriteria.InitCriteria(fieldID, fieldName, ascending);
    this.fSortList.push(sortCriteria);
  }

  AddCriteria2(criteria) {
    this.fSortList.push(criteria);
  }

  Shuffle(criteriaIndex, shuffleUp) {
    var sortCriteria = this.fSortList[criteriaIndex];
    var n = this.GetNumCriteria();
    var newIndex;

    if (shuffleUp) newIndex = criteriaIndex - 1;
    else newIndex = criteriaIndex + 1;

    if (newIndex < 0) return;
    if (newIndex >= n) return;

    var t = this.fSortList[newIndex];
    this.fSortList[newIndex] = sortCriteria;
    this.fSortList[criteriaIndex] = t;
  }

  RemoveCriteriaAtIndex(index) {
    if (index != -1) this.fSortList.splice(index, 1);
  }

  Clone() {
    var c = new QSortConfig();
    c.InitConfig();

    c.fSortScope = this.fSortScope;

    var n = this.GetNumCriteria();
    for (var i = 0; i < n; i++) {
      var criteria = this.GetIndexCriteria(i);
      var critClone = criteria.Clone();
      c.AddCriteria2(critClone);
    }

    return c;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("scope", this.fSortScope, stream);
  }

  OutputChildElements(stream) {
    var n = this.GetNumCriteria();
    for (var i = 0; i < n; i++) {
      var criteria = this.GetIndexCriteria(i);
      criteria.OutputToXML(stream);
    }
  }

  OutputToJSON() {
    let json = { sortConfig: {} };
    var sortConfig = json["sortConfig"];
    sortConfig["scope"] = this.fSortScope;
    sortConfig["criteria"] = [];
    var n = this.GetNumCriteria();
    for (var i = 0; i < n; i++) {
      var criteria = this.GetIndexCriteria(i);
      criteria.OutputToJSON(sortConfig["criteria"]);
    }
    return json;
  }

  LoadFromJSON(json) {
    this.fSortScope =
      json["scope"] && enumSortScope[json["scope"]] != null ? json["scope"] : enumSortScope.chart;
    json["criteria"] = json["criteria"] || [];
    var n = json["criteria"].length;
    this.fSortList = [];
    for (var i = 0; i < n; i++) {
      var criteria = json["criteria"][i];
      var criteriaObj = new QSortCriteria();
      criteriaObj.LoadFromJSON(criteria);
      this.fSortList.push(criteriaObj);
    }
    return this;
  }

  LoadSubElements(objTree) {
    this.InitConfig();
    var scope_obj = objTree.GetChildByName("scope");
    this.fSortScope = parseInt(scope_obj.GetValue());
  }

  LoadChildElements(objTree) {
    var criteriaObjName = "qsortcriteria";
    var childList = objTree.GetChildOfTypeList(criteriaObjName);
    var n = childList.length;
    for (var i = 0; i < n; i++) {
      var c = childList[i];
      var aCriteria = new QSortCriteria();
      aCriteria.SetXMLElementName("qsortcriteria");
      aCriteria.LoadFromXML(c);
      this.fSortList.push(aCriteria);
    }
  }
}
